import { render, staticRenderFns } from "./WorkOwners.vue?vue&type=template&id=cd598b82&lang=pug&"
import script from "./WorkOwners.vue?vue&type=script&lang=js&"
export * from "./WorkOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports